import { TranslationLabels } from "translations/TranslationLabels";

export function isAnonymizedUser(displayName: string | undefined | null): boolean {
  return !!displayName?.toLowerCase().startsWith("anonymized-");
}

export function getAnonymizedAwareDisplayName(displayName: string | undefined | null, i18n: TranslationLabels): string {
  if (isAnonymizedUser(displayName)) {
    return i18n.User_AnonymizedDisplayName;
  }
  return displayName ?? "";
}
